import React from 'react';
import { Navigate } from 'react-router';
import { NavLink, Link } from 'react-router-dom';
import Base from './Base'
import Persons from "./Persons";
import ShareHolders from "./ShareHolders";
import Stuffs from "./Stuffs";
import Warehouses from "./Warehouses";
import BankAccounts from './BankAccounts';
import Units from './Units';
import Accounts from './Accounts';
import Tafsils from './Tafsils';
import CashDesks from './CashDesks';
import Constants from "./Constants";

export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            popupComponent: null,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : [
            this.renderPopupComponent(),
            this.renderForm()
        ];

        return contents;
    }
    changeAnnual(e,id) {
        e.preventDefault();

        this.httpPost("api/v1/common/changeannual", {id})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.location.reload();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return [
            <nav className="navbar navbar-default navbar-fixed-top">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                        {!this.isNull(this.state.data.global.company) && <ul className="nav navbar-nav nav-txt">
                            <li className="dropdown">
                                <a className="dropdown-toggle hand" data-toggle="dropdown" role="button">مالی</a>
                                <ul className="dropdown-menu" role="menu">
                                    <li className="level2"><a>فاکتورها<span className="pull-left"></span></a>
                                        <ul className="level3">
                                            <li><NavLink to="/factors/sale/">فاکتورهای فروش</NavLink></li>
                                            <li><NavLink to="/factors/buy/">فاکتورهای خرید</NavLink></li>
                                            <li><NavLink to="/factors/salereturn/">برگشت از فروش ها</NavLink></li>
                                            <li><NavLink to="/factors/buyreturn/">برگشت از خرید ها</NavLink></li>
                                            {/*<li><NavLink to="/factors/waste/">ضایعات</NavLink></li>*/}
                                        </ul>
                                    </li>
                                    <li><NavLink to="/receipts/">رسیدهای دریافت/پرداخت</NavLink></li>
                                    <li className="level2"><a>چکها<span className="pull-left"></span></a>
                                        <ul className="level3">
                                            <li><NavLink to="/cheques/in/">چک های دریافتی</NavLink></li>
                                            <li><NavLink to="/cheques/out/">چک های پرداختی</NavLink></li>
                                        </ul>
                                    </li>
                                    {/*<li><NavLink to="/documents/">اسناد حسابداری</NavLink></li>*/}
                                    {/*<li><NavLink to="/start/">سند افتتاحیه (مانده اول دوره)</NavLink></li>*/}
                                    {/*<li><NavLink to="/close/">سند اختتامیه (بستن دوره مالی)</NavLink></li>*/}
                                </ul>
                            </li>
                            <li className="dropdown">
                                <a className="dropdown-toggle hand" data-toggle="dropdown" role="button">خرید</a>
                                <ul className="dropdown-menu" role="menu">
                                    <li><NavLink to="/factors/buy/">فاکتورهای خرید</NavLink></li>
                                    <li><NavLink to="/factors/buyreturn/">فاکتورهای برگشت از خرید</NavLink></li>
                                    <li><NavLink to="/receipts/out/">رسیدهای پرداخت</NavLink></li>
                                </ul>
                            </li>
                            <li className="dropdown">
                                <a className="dropdown-toggle hand" data-toggle="dropdown" role="button">فروش</a>
                                <ul className="dropdown-menu" role="menu">
                                    <li><NavLink to="/factors/sale/">فاکتورهای فروش</NavLink></li>
                                    <li><NavLink to="/factors/salereturn/">فاکتورهای برگشت از فروش</NavLink></li>
                                    <li><NavLink to="/receipts/in/">رسیدهای دریافت</NavLink></li>
                                </ul>
                            </li>
                            {this.state.data.global.company.warehouseSystem && <li className="dropdown">
                                <a className="dropdown-toggle hand" data-toggle="dropdown" role="button">انبار</a>
                                <ul className="dropdown-menu" role="menu">
                                    <li><NavLink to="/remittances/out">حواله های انبار</NavLink></li>
                                    <li><NavLink to="/remittances/in">رسیدهای انبار</NavLink></li>
                                    <li className="ng-hide"><NavLink to="/warehouse/handlings/">انبار گردانی</NavLink></li>
                                    <li className="ng-hide"><NavLink to="/buyrequests/">درخواستهای خرید</NavLink></li>
                                    <li className="ng-hide"><NavLink to="/report/inventory/">موجودی کالا</NavLink></li>
                                </ul>
                            </li>}
                            {/*<li className="dropdown">*/}
                            {/*    <a className="dropdown-toggle hand" data-toggle="dropdown" role="button">گزارش ها</a>*/}
                            {/*    <ul className="dropdown-menu" role="menu">*/}
                            {/*        <li><NavLink to="/reports/">تمام گزارش ها</NavLink></li>*/}
                            {/*        <li className="divider"></li>*/}
                            {/*        <li><NavLink to="/report/balance/">ترازنامه</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/income/">صورت سود و زیان</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/capital/">صورتحساب سرمایه</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/journal/">دفتر روزنامه</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/ledger/">دفتر کل، معین و تفصیلی</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/debcred/">بدهکاران و بستانکاران</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/trialbalance/">تراز حساب ها (تراز آزمایشی)</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/explore/">مرور حساب ها</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/banktransaction/">گردش حساب بانک</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/cashtransaction/">گردش حساب صندوق</NavLink></li>*/}
                            {/*        <li><NavLink to="/report/userlog/">لاگ کاربران</NavLink></li>*/}
                            {/*    </ul>*/}
                            {/*</li>*/}
                        </ul>
                        }
                        <ul className="nav navbar-nav navbar-left nav-txt ">
                            {!this.isNull(this.state.data.global.company) && <li className="dropdown">
                                <a className="dropdown-toggle hand" role="button" data-toggle="dropdown" aria-expanded="true">
                                    <span className="fa fa-cog fa-fw" aria-hidden="true" style={{ "font-size": "12pt" }}></span>
                                </a>
                                <ul className="dropdown-menu" role="menu" style={{ "left": "0", "right": "auto" }} >
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <Units Caller={this} /> })}>واحدهای سنجش</a></li>
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <Stuffs Caller={this} /> })}>کالاها و خدمات</a></li>
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <Constants Type={2} Caller={this} /> })}>گروه کالاها و خدمات</a></li>
                                    <li className="divider"></li>
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <Persons Caller={this} /> })}>اشخاص (طرف حسابها)</a></li>
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <Constants Type={1} Caller={this} /> })}>گروه اشخاص (طرف حسابها)</a></li>
                                    {/*<li><a className="hand" onClick={e => this.showComponents({ component: <ShareHolders Caller={this} /> })}>سهامداران</a></li><li className="divider"></li>*/}
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <BankAccounts Caller={this} /> })}>بانک</a></li>
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <CashDesks Caller={this} /> })}>صندوق</a></li>
                                    <li className="divider"></li>
                                    <li><a className="hand" onClick={e => this.showComponents({ component: <Warehouses Caller={this} /> })}>انبارها</a></li>
                                    <li className="divider"></li>
                                    {/*<li><a className="hand" onClick={e => this.showComponents({ component: <Accounts Caller={this} /> })}>جدول حساب ها (کل و معین)</a></li>*/}
                                    {/*<li><a className="hand" onClick={e => this.showComponents({ component: <Tafsils Caller={this} /> })}>حساب های تفصیلی</a></li>*/}
                                    {/*<li><NavLink to="/annual">سال مالی</NavLink></li>*/}
                                    <li><NavLink to="/business/setting">تنظیمات</NavLink></li>
                                    {/*<li className="divider"></li>*/}
                                    {/*<li><NavLink to="/users/">کاربران سیستم</NavLink></li>*/}
                                </ul>
                            </li>}
                            <li>
                                <Link to="/profile/" title="پروفایل">
                                    <span className="fa fa-user fa-fw" aria-hidden="true" style={{ "font-size": "12pt" }} ></span>
                            </Link></li>
                            <li><a onClick={e => this.logOut()} className="hand" title="خروج از برنامه"><span className="fa fa-power-off" aria-hidden="true"></span></a></li>
                        </ul>
                        <ul className="nav navbar-nav navbar-left nav-txt">
                            {!this.isNull(this.state.data.global.company) && 1==2 && <li className="dropdown">
                                <NavLink to="/dashboard/" class="text-gray">{this.state.data.global.company.name}</NavLink>

                                <ul className="dropdown-menu dropdown-menu-left" style={{ "left": "0", "right": "auto", "margin-bottom": "-20px", "width": "285px" }} >
                                    <NavLink to="/" className="list-group-item active">
                                        <strong>کسب و کارهای من</strong>
                                    </NavLink>
                                    {this.state.data.global.companies.map(p => [
                                        <div className="acc-business-item">
                                            <strong>
                                                <a onClick={e => this.changeOrganization(p.id)} className="hand" style={{ "background-color": "transparent", "border": "none", "color": "#337ab7", "font-weight": "bold" }} >{p.name}</a>
                                            </strong>
                                        </div >
                                        ,
                                        this.state.data.global.companies.map(c =>
                                            c.parentId == p.id &&
                                            <div className="acc-business-item">
                                                <strong>
                                                    <a onClick={e => this.changeOrganization(c.id)} className="hand" style={{ "background-color": "transparent", "border": "none", "color": "#337ab7", "font-weight": "bold" }} >{c.name}</a>
                                                </strong>
                                            </div>)
                                    ])}
                                </ul>
                            </li>}
                            {1=== 2 && !this.isNull(this.state.data.global.annual) && <li className="dropdown">
                                <a className="dropdown-toggle hand" role="button" data-toggle="dropdown">{this.state.data.global.annual.title}</a>
                                <ul className="dropdown-menu dropdown-menu-left" style={{ "left": "0", "right": "auto", "margin-bottom": "-20px", "width": "285px" }} >
                                    <span className="list-group-item active">
                                        <strong>سال های مالی</strong>
                                    </span>
                                    {this.state.data.global.annuals.map(a =>
                                        <li method="post" style={{ "width": "100%", "display": "block" }}>
                                            <button onClick={e => this.changeAnnual(e, a.id)} style={{ "width": "100%", "border": "none", "border-radius": "inherit" }} className="list-group-item">
                                                <strong>{a.title}</strong>
                                            </button>
                                        </li>
                                    )
                                    }
                                </ul>
                            </li>
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        ]
    }
}